import { Component, OnInit } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { UpdateTemplate } from "../Model/Catalog/UpdateTemplate";
import { TranslateService } from '@ngx-translate/core';
import { StringResponse } from "../Model/Dto/StringResponse";

@Component({
  selector: "UpdateTemplate",
  templateUrl: "updateTemplate.component.html",
  styleUrls: ["updateTemplate.component.css"]
})
export class UpdateTemplateComponent implements OnInit {

  groups: string[] = [];

  constructor(public modelService: ModelService, public translate: TranslateService) { }

  ngOnInit(): void {
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    }

    this.initFieldsAndGroups();
  }

  public initFieldsAndGroups() {

    this.modelService.catalogService.loadFields();        
    this.groups = this.modelService.updateTemplateService.GetFieldGroups();

  }

  readOnly(field) {
    return false;
  }

  public getHeightRatio(group): number {
    var list = this.modelService.catalogService.fields.filter(item => item.group == group);
    return list.length + 2;
  }

  blockUpdates: boolean = false;
  blockChangedField: boolean = false;

  changedField(event, group) {
    if (!event.event)
      return;

    for (var field of this.modelService.updateTemplateService.selectedTemplate.items) {
      if (field.group == group) {
        if (field.field != "SUPPLIER_PID") {
          field.isActive = event.value;
        }
        else {
          field.isActive = true;
        }
      }
    }
    this.blockUpdates = false;
    this.update(event);
  }

  isGroupSelected(group) {
    let allFields = this.modelService.updateTemplateService.selectedTemplate.items;
    return !allFields.some(x => x.group == group && !x.isActive);
  }

  get fields() {
    return this.modelService.catalogService.fields;
  }

  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(true), ms)).then(() => console.log("fired"));
  }

  get showPlaceHolders() {
    return this.modelService.loginService.showPlaceHolders;
  }

  update(e) {
    if (this.blockUpdates || !e.event)
      return;
    this.blockChangedField = true;
    this.modelService.updateTemplateService.updateUpdateTemplate(this.modelService.updateTemplateService.selectedTemplate).subscribe(
      (result: StringResponse) => {
        this.delay(100).then(any => {
          this.blockChangedField = false;
        });
      });
  }
}
